import { mockAutomatedData } from './mock';
import { MetricType } from './types';
// TODO: Connect with real data when be is ready
export var useMetrics = function () {
    var metrics = new Map([
        [
            MetricType.AUDIENCE,
            {
                title: 'AUDIENCE',
                value: "".concat(mockAutomatedData.metrics.audience.count.toLocaleString(), " clients"),
                subtitle: mockAutomatedData.metrics.audience.description,
            },
        ],
        [
            MetricType.SENT,
            {
                title: 'SENT',
                value: "".concat(mockAutomatedData.metrics.sent.campaigns, " campaigns"),
                subtitle: mockAutomatedData.metrics.sent.since,
            },
        ],
        [
            MetricType.OPEN_RATE,
            {
                title: 'OPEN RATE',
                value: "".concat(mockAutomatedData.metrics.openRate.percentage, "%"),
                subtitle: "".concat(mockAutomatedData.metrics.openRate.clients, " clients"),
            },
        ],
    ]);
    return {
        metrics: metrics,
    };
};
